// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".customer-list .admin-table tbody{display:block;height:calc(100vh - 320px);overflow-y:scroll}.customer-list .admin-table tbody tr,.customer-list .admin-table thead tr{display:table;width:100%;table-layout:fixed}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
